import { ChangeEventHandler, FC } from "react";
import { Box, Checkbox, FormGroup, FormControlLabel } from "@mui/material";
import DoneIcon from "../../../assets/svg-fc/DoneIcon";
import palette from "../../../theme/palette";
import "./checkboxLabel.css";

interface iCheckboxLabelProps {
	label: string;
	required?: boolean;
	disabled?: boolean;
	className?: string;
	checked?: boolean;
	onChange?: ChangeEventHandler<HTMLInputElement>;
}

const CheckboxLabel: FC<iCheckboxLabelProps> = ({
	label,
	required,
	disabled,
	className,
	onChange,
	checked,
}) => {
	return (
		<FormGroup className="checkboxLabel">
			<FormControlLabel
				control={
					<Checkbox
						disableRipple
						icon={<Box className={`checkboxIcon ${disabled ? "disabled" : ""}`} />}
						checkedIcon={
							<Box className="checkboxIcon checked">
								<DoneIcon stroke={palette.primary.main} strokeWidth="2" />
							</Box>
						}
						checked={!!checked}
						onChange={onChange}
					/>
				}
				label={label}
				required={required}
				disabled={disabled}
				className={className}
			/>
		</FormGroup>
	);
};
export default CheckboxLabel;
